import gql from "graphql-tag";

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser($id: ID!, $userInputDetails: UserInput!) {
    updateUser(id: $id, userInput: $userInputDetails) {
      id
      email
      phone
      uniqueIdentifier
      advisorCode
    }
  }
`;

export const CREATE_USER_MUTATION = gql`
  mutation createUser(
    $userInputDetails: UserInput!
    $sendEmail: Boolean
    $willCountry: WillCountryEnum!
  ) {
    createUser(
      userInput: $userInputDetails
      sendEmail: $sendEmail
      willCountry: $willCountry
    ) {
      email
      fullName
      role
      activationLink
      phone
      uniqueIdentifier
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword(
    $resetPasswordCode: String!
    $password: String!
    $acceptedTerms: Boolean
  ) {
    resetPassword(
      resetPasswordCode: $resetPasswordCode
      password: $password
      acceptedTerms: $acceptedTerms
    )
  }
`;

export const SEND_OTP_MUTATION = gql`
  mutation sendOtp($testatorId: ID!) {
    sendOtp(testatorId: $testatorId) {
      status
      message
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation verifyOtp($testatorId: ID!, $otp: String!) {
    verifyOtp(testatorId: $testatorId, otp: $otp)
  }
`;

export const VERIFY_USER_LINK_CODE_QUERY = gql`
  query verifyUserLinkCode($code: String!) {
    verifyUserLinkCode(code: $code) {
      validCode
      acceptedTerms
      email
      phone
      uniqueIdentifier
      used
      linkType
      companyLogoUrl
      companyName
      bannerTitle
      bannerDescription
      companyOffersFreeWill
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword(
    $authenticationValue: String!
    $authenticationField: String
  ) {
    forgotPassword(
      authenticationValue: $authenticationValue
      authenticationField: $authenticationField
    )
  }
`;

export const CREATE_ACTIVATION_LINK_MUTATION = gql`
  mutation createActivationLink($testatorId: ID!) {
    createActivationLink(testatorId: $testatorId)
  }
`;

export const EDIT_USER_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      fullName
      firstNames
      lastName
      email
      phone
      uniqueIdentifier
      role
      externalReference
      advisorCode
      companyId
      branchId
      appointmentLink
      systemWideAccess
      companyWideAccess
      managerEmail
      sppProvider
      omipayCode
      testator {
        id
        cellNumber
        cellCountryCode
        advisor {
          id
          email
        }
      }
      commissionStructure
      objectCommissionPairs {
        id
        commissionObjectType
        commissionObjectId
        parentObjectType
        parentObjectId
        limitAmount
        limitDate
        usedAmount
        active
        limit
        willCommission {
          id
          trigger
          value
          valueCents
          createdAt
          updatedAt
        }
        policyCommission {
          id
          type
          value
          cadence
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GENERATE_REFERRAL_LINK_MUTATION = gql`
  mutation generateReferralLink($userId: ID!) {
    generateReferralLink(userId: $userId)
  }
`;

export const AUDIT_TRAIL_QUERY = gql`
  query auditTrail(
    $userId: ID!
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDesc: Boolean
    $search: String
  ) {
    auditTrail(
      userId: $userId
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDesc: $sortDesc
      search: $search
    ) {
      totalVersions
      versions {
        id
        itemType
        itemId
        event
        whodunnit
        objectChanges
        testatorId
        testatorName
        createdAt
        extraDetail
        testatorEmail
      }
    }
  }
`;

export const AUDIT_TRAIL_USER_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      fullName
      firstNames
      lastName
      email
      role
      testator {
        id
      }
    }
  }
`;
